import { Button, Card, Col, Input, Pagination, Row, Spin, Table, App, Tooltip, Modal, Popconfirm, Tag } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { EyeFilled, LoadingOutlined, CopyOutlined, DeleteOutlined, EditFilled, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom'
import { LIST_PREDEFINE_TEMPLATE, DELETE_PREDEFINE_TEMPLATE, VIEW_PREDEFINE_TEMPLATE,PREDEFINE_TEMPLATE_STATUS } from '../../../Admin-panel/apis/apis';
import debounce from 'lodash.debounce';
import CulsightPageLoader from '../../../Admin-panel/components/CulsightPageLoader';
import DOMPurify from "dompurify";

function PreEmailTemplate() {
  const { modal,notification } = App.useApp();
  
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_email_template, set_total_email_template] = useState("");
  const [search_query_name, set_search_query_name] = useState("");
  const [onchange_call, set_onchange_call] = useState(false);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewName, setPreviewName] = useState("");
  const [previewSubject, setPreviewSubject] = useState("");

  // LIST API
  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await LIST_PREDEFINE_TEMPLATE(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_email_template(API_CALL?.data?.total_email_template);


      if (API_CALL?.data?.admin_id) {
        localStorage.setItem("admin_id", API_CALL?.data?.admin_id);
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    LIST_API();
  }, [onchange_call]);

  // PREVIEW FUNCTION
  const handlePreview = async (id) => {
    setPreviewLoader(true);
    setPreviewModal(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    const API = await VIEW_PREDEFINE_TEMPLATE(FORM_DATA);

    if (API?.data?.status) {
      const data = API?.data?.data;
      setPreviewName(data?.name);
      setPreviewSubject(data?.subject);
      setPreviewHtml(data?.message_value || "<h3>No Preview Available</h3>");
    }
    setPreviewLoader(false);
  };

  // COPY EMAIL
  // COPY EMAIL with Confirm
  // const handleCopy = (id) => {
  //   modal.confirm({
  //     title: "Do you want to duplicate this email template?",
  //     okText: "Copy",
  //     cancelText: "Cancel",
  //     onOk: async () => {
  //       const FORM_DATA = new FormData();
  //       FORM_DATA.append("id", id);

  //       const response = await COPY_EMAIL(FORM_DATA);
  //       if (response?.data?.status) {
  //         message.success("Email template copied successfully");
  //         navigate("/edit-email/" + btoa(response?.data?.data?.id));
  //       } else {
  //         message.error("Failed to copy");
  //       }
  //     }
  //   });
  // };


  // SEARCH debounce
  const fetchResultsName = useCallback(debounce(async (value) => {
    set_search_query_name(value);
    set_pagination_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("name", value);
    const API_CALL = await LIST_PREDEFINE_TEMPLATE(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_email_template(API_CALL?.data?.total_email_template);
    }
    set_pagination_loader(false);
  }, 500), []);

  const handleInput = (e) => {
    fetchResultsName(e.target.value);
  };

  const pagination_on_change = async (page) => {
    set_pagination_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("name", search_query_name);

    const API_CALL = await LIST_PREDEFINE_TEMPLATE(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_email_template(API_CALL?.data?.total_email_template);
    }
    set_pagination_loader(false);
  };
   const change_status = async (id) => {
    setLoader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    try {
      const response = await PREDEFINE_TEMPLATE_STATUS(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message || "Status updated successfully",
        });
        set_onchange_call(onchange_call ? false : true)
          // setLoader(false);

      } else {
          notification.error({
        message: "Failed",
        description: response?.data?.message || "Unable to change status",
      });
       

      }
    } catch (error) {
     notification.error({
      message: "Server Error",
      description:
        error?.response?.data?.message || "Something went wrong",
    });

    }
      finally {
    setLoader(false);
      } 
  };

  // DELETE CONFIRM
  const handleDelete = (id) => {
    modal.confirm({
      title: "Are you sure want to delete?",
      onOk: async () => {
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", id);

        const response = await DELETE_PREDEFINE_TEMPLATE(FORM_DATA);
        if (response?.data?.status) {
         notification.success({
            message: "Successful",
            description: response?.data?.message || "Template deleted successfully",
          });
          
          LIST_API();
        } else {
          notification.error({
            message: "Delete Failed",
            description: response?.data?.message || "Unable to delete template",
          });
        }
      }
    });
  };

  const columns = [
    { title: "Name", dataIndex: "name" },
    { title: "Subject", dataIndex: "subject" },
    // {
    //   title: "User Count",
    //   render: (_, record) => <span>{record.email_template_count}</span>,
    // },

     {
      title: "Status",
      key: "status",
      render: (text, record) => (
        <span>
          {record.status ? (
            <>
              <Tag color="success">Active</Tag>
            </>
          ) : (
            <>
              <Tag color="error">Inactive</Tag>
            </>
          )}
        </span>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
         
          <Tooltip title="Edit">
            <Button icon={<EditFilled />} size="small" type="primary"
              onClick={() => navigate("/edit-pre-email-template/" + btoa(record.id))}
            />
          </Tooltip>


          <Tooltip title="Preview">
            <Button icon={<EyeFilled />} size="small" type="primary"
              onClick={() => handlePreview(record.id)}
            />
          </Tooltip>

           
        <Popconfirm
  title="Do you want to change the status?"
  onConfirm={() => change_status(record?.id)}
  okText="Yes"
  cancelText="No"
>
  <Tooltip title="Change Status">
    <Button
      size="small"
      style={{
        backgroundColor: record.status ? "#52c41a" : "#ff4d4f",
        borderColor: record.status ? "#52c41a" : "#ff4d4f",
        color: "#fff"
      }}
      icon={
        record.status ? (
          <CheckOutlined />
        ) : (
          <CloseOutlined />
        )
      }
    />
  </Tooltip>
</Popconfirm>


<Tooltip title="Delete">
            <Button icon={<DeleteOutlined />} danger size="small" type="primary"
              onClick={() => handleDelete(record.id)}
            />
          </Tooltip>

          {/* <Tooltip title="Copy">
            <Button
              icon={<CopyOutlined />}
              size="small"
              type="primary"
              onClick={() => handleCopy(record.id)}
            />
          </Tooltip> */}


        </div>
      ),
    }
  ];

  return (
    <div className='lms-body'>
      <Row>
        <Col span={12}>
          <h2>Email Templates</h2>
        </Col>
      </Row>

      <Card>
        <Row gutter={12}>
          <Col span={20}>
            <Input
              addonBefore="Name"
              placeholder="Search by name"
              onChange={handleInput}
              size="large"
            />
          </Col>

          <Col span={4}>
            <Button size="large" type='primary' style={{ width: "100%" }}
              onClick={() => navigate("/add-pre-email-template")}
            >
              Add Email
            </Button>
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : pagination_loader ? (
          <div style={{ textAlign: "center", padding: "60px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              dataSource={table_data}
              pagination={false}
              style={{ marginTop: "15px" }}
            />

            <div style={{ float: "right", marginTop: "20px" }}>
              <Pagination
                onChange={pagination_on_change}
                current={current_page}
                total={total_email_template}
                pageSize={10}
              />
            </div>
          </>
        )}
      </Card>

      {/* 🔥 Fixed Preview Modal */}
      <Modal
        title={`Preview - ${previewSubject}`}
        open={previewModal}
        onCancel={() => setPreviewModal(false)}
        footer={null}
        width={900}
      >
        {previewLoader ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <div
            style={{
              background: "#0f0f0fff",
              maxHeight: "70vh",
              overflowY: "auto",
              padding: "20px",
              border: "1px solid #131111ff",
              borderRadius: "8px"
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(previewHtml),
            }}
          />
        )}
      </Modal>
    </div>
  );
}

export default PreEmailTemplate;
